import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-secondary-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-book-read-line text-xl text-accent-400"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50">韩漫网</span>
              </Link>
              <p className="text-sm text-secondary-400 leading-relaxed">
                韩漫网是免费韩漫大全平台，为您提供最新最全的韩国漫画在线阅读服务。每日更新，免费畅享正版韩漫阅读体验。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">漫画分类</h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 4).map((cat) => (
                  <li key={cat.slug}>
                    <Link to={`/category/${cat.slug}`} className="text-sm text-secondary-400 hover:text-accent-400 transition-colors whitespace-nowrap">
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">更多分类</h4>
              <ul className="space-y-2.5">
                {categories.slice(4).map((cat) => (
                  <li key={cat.slug}>
                    <Link to={`/category/${cat.slug}`} className="text-sm text-secondary-400 hover:text-accent-400 transition-colors whitespace-nowrap">
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">关于我们</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/about" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors whitespace-nowrap">品牌介绍</Link>
                </li>
                <li>
                  <a href="/about#contact" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors whitespace-nowrap">联系我们</a>
                </li>
              </ul>
              <div className="flex items-center gap-3 mt-5">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-accent-500 transition-colors cursor-pointer" rel="nofollow">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-accent-500 transition-colors cursor-pointer" rel="nofollow">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-accent-500 transition-colors cursor-pointer" rel="nofollow">
                  <i className="ri-bilibili-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-secondary-700 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-secondary-500">
              &copy; 2024 - 2026 韩漫网 HanMan. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-sm text-secondary-500 hover:text-secondary-300 transition-colors whitespace-nowrap">用户协议</a>
              <a href="#" className="text-sm text-secondary-500 hover:text-secondary-300 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-sm text-secondary-500 hover:text-secondary-300 transition-colors whitespace-nowrap">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}